/**
 * Classe de création de tooltip sous forme de pop'in
 * */
export class IsiPopinTooltipInitializer {

    private readonly _isHierarchical: boolean;
    private readonly _isHtml: boolean;
    private readonly _dtoPropertiesToChange: Array<{ dtoPropertyName: string, value: any }>;
    private _tooltipContent: string;
    private _popin;

    /**
     * Constructeur de la classe
     * */

    constructor(isHierarchical: boolean, isHtml: boolean, tooltipContent: string) {
        this._isHierarchical = isHierarchical;
        this._isHtml = isHtml;
        this._tooltipContent = tooltipContent;
        this._dtoPropertiesToChange = new Array<{ dtoPropertyName: string, value: any }>();
        this._popin = uiCore.popinCmp;
    }

    /**
     * Permet d'obtenir la pop'in si l'utilisateur souhaite faire des choses en plus dessus
     * */
    getPopin() {
        return this._popin;
    }

    /**
     * Initialise la variable locale de popin par celle donnée en paramètre
     * */
    setPopin(popin) {
        this._popin = popin;

    }

    /**
     * Change le contenu de la pop'in (texte à l'intérieur de la pop'in)
     * */
    setPopinContent(content: string) {
        this._tooltipContent = content;
        this._popin.getExternalContentContainer().html(content)
    }

    /**
     * Initialise la barre de boutons en bas de la pop'in
     * */
    setBottomBarButtons() {
        this._popin.setBottomBarButtons.apply(this._popin, arguments);
        this._popin.refreshElements();
    }

    /**
     * Initialise la pop'in avec les infos de la tooltip
     * */
    init() {

        if (this._popin) {

            this._createAndChangePopin()

            this._popin.getExternalContentContainer().html(this._getPopinContent())
        }
    }

    /**
     * Initialise la pop'in avec le style pour le multiligne
     * */
    initForMultiLignes(canEdit: boolean, isRich: boolean, restriction: Function) {

        if (this._popin) {

            this._createAndChangePopin()

            this._popin.getExternalContentContainer().html(this._getMultilignePopinContent(canEdit, isRich, restriction));
        }
    }

    /**
     * Ajoute une propriété du dto à changer
     * */
    addDtoPropertyToChange(dtoPropertyName: string, value: any) {
        this._dtoPropertiesToChange.push({ dtoPropertyName, value });
    }

    /**
     * Affiche la pop'in liée à l'initialisateur
     * */
    show() {
        this._popin.show();
    }

    // Private methods

    /**
     * Construit le contenu de la pop'in à partir des infos du constructeur
     * */
    _getPopinContent() {
        let divContainer, content;
        if (this._isHierarchical) { // si on est dans le cas d'un tooltip hierarchique
            divContainer = jQuery('<div class="toolTipHier"></div>');
            content = jQuery('<div class="toolTipHierContainer"></div>');

            // On créé la sous structure
            const fields = this._tooltipContent.split('\\');
            let marginLeft = 12;

            for (const field of fields) {
                const item = jQuery('<div class="toolTipHierItem"></div>');
                item.css('margin-left', marginLeft + 'px');
                item.text(field);

                content.append(item);
                marginLeft = marginLeft + 4;
            }
            divContainer.append(content);
        } else { // cas d'un tooltip simple
            divContainer = jQuery('<div class="toolTipContainer"></div>');

            if (this._isHtml) {
                divContainer.append(this._tooltipContent);
            } else {
                divContainer.text(this._tooltipContent);
            }
        }

        return divContainer;
    }

    /**
     * Obtient le contenu de la pop'in et le stylise pour donner le style de pop'in multiligne.
     * Sert aussi pour les champs riches.
     * */
    _getMultilignePopinContent(canEdit: boolean, isRich: boolean, restrictionFunction: Function) {
        let content, readOnly;

        // Lorsque le champ est desactive, alors le contenu de la popin n'est pas modifiable non plus
        if (canEdit) {
            readOnly = "";
        } else {
            readOnly = "readOnly";
        }

        // Creation du conteneur
        const divContainer = jQuery('<div class="memoDetailContainer ' + readOnly + '"></div>');

        if (isRich) {
            // Création de la div spécifique pour accueillir le texte riche
            content = jQuery('<div class="memoDetailContent">' + this._tooltipContent + '</div>');
        } else {
            let restriction = restrictionFunction()
            
            if (restriction === undefined) {
                restriction = ""
            } 
            // Creation de la zone de saisie
            content = jQuery('<textarea class="memoDetailContent" type="input" ' + readOnly + restriction + '>' + this._tooltipContent + '</textarea>');

        }

        divContainer.append(content);
        return divContainer;
    }

    /**
     * Met à jour une propriété du dto de la pop'in associée
     * */
    _updatePopinDtoProperty(dtoProperty:{dtoPropertyName: string, value: any}) {
        this._popin.updateDtoProperty(dtoProperty.dtoPropertyName, dtoProperty.value);
    }

    /**
     * Traitement lié aux initialiseurs de pop'in tooltip
     * */
    _createAndChangePopin() {
        this._popin.getJQueryElement().addClass("InfoBulle");

        // ATTENTION : tous les paramètres du dto doivent être réinitialisés AVANT de les modifiés CAR l'état actuel du dto est inconnu !!!
        this._popin.resetDefaultSettings();

        this._dtoPropertiesToChange.forEach(function (dtoProperty) {
            this._updatePopinDtoProperty(dtoProperty)
        }, this)

        // Maj du composant
        this._popin.refreshElements();
    }

}
